
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import EmployeeBarCodeModal from './EmployeeBarCodeModal'
import FontAwesome from 'react-fontawesome'
class EmployeeBarCodeButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    this.setState({show:true})
  }

  render(){
    let {show} = this.state
    return (
      <div>
        <Button  onClick={this.onClick.bind(this)}>
          <FontAwesome name='barcode'/>{' '} Barcode
        </Button>
        <EmployeeBarCodeModal
        {...this.props} 
        show={show}                 
        onHide={()=>{this.setState({show:false})}}/>
      </div>
    )
  }
}

export default EmployeeBarCodeButton;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeBarCodeButton.js